const defaultPrinterKey = "default_printer";
const defaultTicketPrinterKey = "ticket_printer";
const autoPrintKey = "printAutomatically";
export const USE_COMPUTER_PRINT_DIALOG = "USE_COMPUTER_PRINT_DIALOG";

export const setDefaultPrinter = (printer: string | null) => {
    if (printer) {
        localStorage.setItem(defaultPrinterKey, printer);
    } else {
        localStorage.removeItem(defaultPrinterKey);
    }
};

export const setTicketPrinter = (printer: string | null) => {
    if (printer) {
        localStorage.setItem(defaultTicketPrinterKey, printer);
    } else {
        localStorage.removeItem(defaultTicketPrinterKey);
    }
};

export const getTicketPrinter = () => {
    return localStorage.getItem(defaultTicketPrinterKey);
};

export const getDefaultPrinter = () => {
    return localStorage.getItem(defaultPrinterKey);
};

export const setAutoPrint = (autoPrint: boolean) => {
    localStorage.setItem(autoPrintKey, String(autoPrint));
};

export const getAutoPrint = () => {
    return localStorage.getItem(autoPrintKey) === "true";
};

export const shouldUseBrowserPrintDialog = () => {
    const defaultPrinter = getDefaultPrinter();
    return defaultPrinter === USE_COMPUTER_PRINT_DIALOG;
};
